import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import {
  GET_AI_SEARCHDATA,
  GET_ALL_BRAND,
  GET_ALL_CATEGORY,
  GET_ALL_HEALTH_CONDITION,
  GET_BLOG,
  GET_FAQ,
  GET_PAGES,
  GET_PRIMARY_MENU,
  GET_SEARCHDATA,
} from "../routes";

export const commonApi = createApi({
  reducerPath: "commonApi",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getPrimaryMenu: builder.query({
      query: () => GET_PRIMARY_MENU,
      transformResponse: (response: ApiResponse<PrimaryMenuCategory[]>) => {
        return response?.data;
      },
    }),
    getFaq: builder.query({
      query: () => GET_FAQ,
      transformResponse: (response: ApiResponse<faqTypes[]>) => {
        return response?.data;
      },
    }),
    getBlog: builder.query({
      query: (q) => ({
        url: GET_BLOG,
        params: { type: q ? q : undefined },
      }),
      transformResponse: (response: ApiResponse<BlogPost[]>) => {
        return response?.data;
      },
    }),
    getSearchData: builder.query({
      query: (q: string) => ({
        url: GET_SEARCHDATA,
        params: { q },
      }),
      transformResponse: (
        response: ApiResponse<SearchMedicineDetailTypes[]>
      ) => {
        return response?.data;
      },
    }),
    getAiSearchData: builder.query({
      query: (q: string) => ({
        url: GET_AI_SEARCHDATA,
        params: { q },
      }),
      transformResponse: (response: ApiResponse<searchAIResponseType>) => {
        return response?.data;
      },
    }),
    getAllCategory: builder.query({
      query: (data: { q?: string; page: number }) => ({
        url: GET_ALL_CATEGORY,
        params: {
          q: data?.q,
          page: data?.page,
        },
      }),
      transformResponse: (response: ApiResponse<MedicineCategory[]>) => {
        return response;
      },
    }),
    getAllBrand: builder.query({
      query: (data: { q?: string; page: number }) => ({
        url: GET_ALL_BRAND,
        params: {
          q: data?.q,
          page: data?.page,
        },
      }),
      transformResponse: (response: ApiResponse<Brand[]>) => {
        return response;
      },
    }),
    getAllHealthCondition: builder.query({
      query: (data: { q?: string; page: number }) => ({
        url: GET_ALL_HEALTH_CONDITION,
        params: {
          q: data?.q,
          page: data?.page,
        },
      }),
      transformResponse: (response: HealthConditions2Types) => {
        return response;
      },
    }),
    getPages: builder.query({
      query: (slug) => ({
        url: GET_PAGES,
        params: { slug },
      }),
      transformResponse: (response: PageApiResponse<PagePostTypes>) => {
        return response?.posts;
      },
    }),
  }),
});

export const {
  useGetPrimaryMenuQuery,
  useLazyGetSearchDataQuery,
  useLazyGetAiSearchDataQuery,
  useLazyGetAllCategoryQuery,
  useLazyGetAllBrandQuery,
  useLazyGetAllHealthConditionQuery,
  useGetFaqQuery,
  useGetBlogQuery,
  useGetPagesQuery,
} = commonApi;
